export default "__VITE_ASSET__7WcIoDet__"